import Reveal from "./Reveal";

const skills = [
    "DART / FLUTTER", "KOTLIN", "CLEAN ARCHITECTURE / SOLID", "BLOC / CUBIT",
    "PLATFORM CHANNELS", "FIREBASE", "FIREBASE CLOUD FUNCTIONS", "REVENUECAT",
    "REST API / DIO", "FREEZED / JSON_SERIALIZABLE", "GITLAB CI/CD","GIT", "GET_IT / INJECTABLE",
    "HIVE / ROOM", "SENTRY", "APPMETRICA / APPSFLYER",
];

const PORTRAIT = "/portrait.jpeg";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative border-t border-white/5 py-16 lg:py-24">
            <div
                className="pointer-events-none absolute inset-0"
                style={{background: "radial-gradient(ellipse 50% 40% at 15% 60%, rgba(59,130,246,0.05), transparent 60%)"}}
                aria-hidden="true"
            />
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <div className="font-mono text-xs tracking-[0.35em] text-accent">[ 02 ]</div>
                    <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
                        About
                    </h2>
                </Reveal>

                <div className="mt-20 grid grid-cols-1 gap-16 lg:grid-cols-12">
                    <Reveal className="lg:col-span-5" delay={0.1}>
                        <div className="group relative max-w-sm">
                            <div
                                className="absolute -inset-4 rounded-2xl bg-accent/10 opacity-0 blur-2xl transition-opacity duration-700 group-hover:opacity-100"
                                aria-hidden="true"/>
                            <div className="relative overflow-hidden rounded-2xl border border-white/10">
                                <img
                                    src={PORTRAIT}
                                    alt="Portrait of Dmitriy Trapezniko"
                                    data-testid="about-portrait"
                                    className="block h-auto w-full grayscale transition-all duration-700 group-hover:grayscale-0"
                                />
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent"/>
                                <div className="absolute bottom-5 left-5">
                                    <div className="font-mono text-[10px] tracking-[0.3em] text-zinc-400">BASED IN</div>
                                    <div className="font-display text-lg font-semibold text-white">Tbilsi, Georgia</div>
                                </div>
                            </div>
                        </div>
                    </Reveal>

                    <div className="lg:col-span-7">
                        <Reveal delay={0.15}>
                            <p className="max-w-xl text-lg leading-relaxed text-zinc-300 md:text-xl">
                                I’m a Senior Flutter Developer with <span className="text-white">5+ years</span> of
                                experience in mobile development. I build iOS and Android apps from scratch and
                                improve existing products across e-commerce, subscription apps, and enterprise software.
                            </p>
                            <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
                                My work spans app architecture, payments, native integrations, and complex workflows —
                                from AI coaching to field-service tools with OCR and GPS tracking. I focus on building
                                reliable features and keeping the codebase easy to maintain as the product grows.
                            </p>
                        </Reveal>

                        <Reveal delay={0.25} className="mt-16">
                            <div className="font-mono text-xs tracking-[0.35em] text-accent">[ 03 ]</div>
                            <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
                                Technical Skills
                            </h3>
                            <div className="mt-8 flex max-w-2xl flex-wrap gap-2.5" data-testid="skills-grid">
                                {skills.map((s) => (
                                    <span
                                        key={s}
                                        className="cursor-default rounded-full border border-white/10 bg-surface px-4 py-2 font-mono text-[11px] tracking-[0.15em] text-zinc-300 transition-all duration-300 hover:-translate-y-0.5 hover:border-accent/40 hover:text-white hover:shadow-[0_4px_20px_rgba(59,130,246,0.15)]"
                                    >
                    {s}
                  </span>
                                ))}
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
